import { CommonPaginator, usePaginated } from './usePaginated'
import { ExtraOperation } from 'depoto-core'
import { useCallback, useMemo } from 'react'
import { removeEmptyProperties } from '../'
import { useCore } from '../../hooks'

// !+!+!+!+!+!+!+!+!+!+
// Module was moved from RN Terminal
// Please do not remove unknown and "unused" functions.
// !+!+!+!+!+!+!+!+!+!+

export type CheckoutExtraOperationsFilters = Partial<{
  checkouts?: number[]
  checkout?: number
  checkoutClosing?: number
}>

const clientFilterKeys = []

interface Params {
  filters?: CheckoutExtraOperationsFilters
  sort?: string
  direction?: string
  schema?: any
}

export function usePaginatedCheckoutExtraOperations(params: Params = {}) {
  const { filters, schema = { id: null }, sort = 'id', direction = 'DESC' } = params
  const { core } = useCore()

  const serverFilters = useMemo(
    () =>
      removeEmptyProperties(
        Object.fromEntries(Object.entries(filters || {}).filter(([key]) => !clientFilterKeys.includes(key))),
      ),
    [filters],
  )

  const fetchCheckoutExtraOperations = useCallback(
    async (page: number) => {
      const params: any = removeEmptyProperties({
        direction,
        filters: serverFilters,
        page,
        sort: sort,
      })

      return (await core.services.checkout.getCheckoutExtraOperationList(params, schema)) as {
        items: ExtraOperation[]
        paginator: CommonPaginator
      }
    },
    [core.services.checkout, serverFilters, sort],
  )

  const {
    isLastPage,
    loadMore,
    loading,
    refresh,
    items: checkoutExtraOperations,
    totalCount,
  } = usePaginated<ExtraOperation>({
    queryKey: ['checkoutExtraOperations', filters, sort, direction],
    fetchItems: fetchCheckoutExtraOperations,
  })

  return {
    isLastPage,
    loadMore,
    loading,
    checkoutExtraOperations,
    refresh,
    totalCount,
  }
}
